"use strict";
import { useContext, useMemo } from "react";
import { ShellContext } from "../context";
import { useOwnerModule } from "./useOwnerModule";
export const useDataChannel = (...args) => {
  let moduleId;
  let channelId;
  const ownerModule = useOwnerModule();
  if (args.length === 1) {
    moduleId = ownerModule ? ownerModule.id : null;
    channelId = args[0];
  } else {
    moduleId = args[0];
    channelId = args[1];
  }
  const { getChannelSubscriptions } = useContext(ShellContext);
  const channelSubscriptions = useMemo(() => {
    return getChannelSubscriptions(moduleId, channelId).filter((subscription) => subscription.type === "data");
  }, [getChannelSubscriptions, moduleId, channelId]);
  return channelSubscriptions;
};
